<template>
  <v-container>
    <v-container>
      <v-sheet>
        <v-card-title>{{ $t("galleryTitle") }}</v-card-title>
        <v-container>
          <v-row dense>
            <v-col
              v-for="(image, k) in location.images"
              :key="k"
              :md="2"
              :sm="4"
            >
              <v-card tile>
                <v-img :src="image.url" height="150px"></v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "LocationGallery",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  computed: {
    ...mapGetters(["location"]),
  },
};
</script>
